import React from "react";
import { useTranslation } from "react-i18next";

export default function Legend() {
  const { t } = useTranslation();
  return (
    <div className="sch-legend">
      <span className="lg">
        <i className="dot good" />
        {t("schools.lgGood")}
      </span>
      <span className="lg">
        <i className="dot bad" />
        {t("schools.lgBad")}
      </span>
      <span className="lg qnote">{t("schools.lgNote")}</span>
      <span className="lg qnote">{t("schools.lgCat")}</span>
    </div>
  );
}
